/* Dropdayz — productfoto's automatisch op één schaal. 22 augustus 2026.

   WAAROM DIT BESTAAT. De tegel achter de foto legt bloot hoe verschillend de
   productfoto's zijn opgemaakt: bij de ene sneaker staat de schoen strak in
   het kader, bij de andere klein in een groot leeg vlak. Gemeten over alle
   358 sneakers: de contour vult 55% tot 79% van de tegelbreedte.

   CSS kan dat niet oplossen. CSS weet hoe groot een bestand is, niet waar in
   dat bestand het product staat. En een thema kan niet aan de uploadknop
   hangen — het draait pas als een bezoeker een pagina opent.

   WAT DIT SCRIPT DOET. Het meet de contour van de foto (in een canvas van
   96px breed, dus goedkoop) en zet er een transform op zodat die contour
   altijd in een vast doelvak past. Daarmee vult elk product evenveel van de
   tegel, ongeacht hoe de foto is aangeleverd.

   HET DOELVAK is 74% van de tegelbreedte bij 64% van de tegelhoogte, en de
   contour wordt daarin PASSEND gemaakt (niet uitgerekt). Wil je het geheel
   groter of kleiner, verander alleen DOEL_B en DOEL_H hieronder.

   WAT ALS METEN MISLUKT. Dan gebeurt er niets en staat de foto zoals hij
   altijd stond. Geen enkele stap is verplicht voor een werkende kaart.

   ------------------------------------------------------------------
   NIEUW 24 AUG 2026 — GRIJZE OF WITTE TEGEL, AUTOMATISCH

   Van de 892 producten zijn alleen de 358 sneakers vrijstaand gemaakt. Bij
   de rest (kleding, accessoires, speelgoed) staat het product nog op wit, en
   wit op een grijze tegel is een lelijk wit blok — gemeld door de eigenaar
   bij de KAWS op de zoekpagina.

   Dit script kijkt tijdens het meten toch al naar de doorzichtigheid van
   elke pixel. Datzelfde canvas vertelt of de RAND van de foto doorzichtig
   is. Zo niet, dan krijgt de tegel de klasse ddz-tegel--wit en wordt hij wit
   in plaats van grijs (assets/ddz-fixes-livegang.css). De foto valt dan
   naadloos weg in de tegel in plaats van als blok op te vallen.

   Gevolg: vrijstaande foto = grijze tegel met contactschaduw, foto op wit =
   witte tegel zonder schaduw. Beide zien er verzorgd uit, en toekomstige
   uploads regelen zichzelf.

   De cachesleutel is daarom van v1 naar v2 gegaan: oude metingen weten nog
   niet of een foto ondoorzichtig is en moeten opnieuw.
   ------------------------------------------------------------------

   ACHTERGROND MEETELLEN. Een pixel telt als product als hij niet doorzichtig
   én niet bijna-wit is. Daarmee werkt het op vrijstaande PNG's én op foto's
   die nog een witte achtergrond hebben.

   ONTHOUDEN. Elke meting gaat in localStorage onder de bestandsnaam. Een
   tweede bezoek, of de volgende pagina, gebruikt die meting meteen.

   DE KLASSE ddz-fit-klaar. Zodra een foto zijn schaal heeft gekregen, komt er
   NÁ een tel de klasse ddz-fit-klaar bij. Alleen die klasse krijgt in
   ddz-kaart-v3-hover.css een transitie op transform en filter, zodat het
   optillen bij hover soepel gaat. Zou de transitie er meteen op staan, dan
   animeerde die allereerste schaalsprong mee en groeide elke foto zichtbaar
   bij het laden. De vertraging is dus geen slordigheid maar het hele punt.

   DRIE VALKUILEN DIE HET AL EEN KEER SLOOPTEN — niet terugdraaien:

   1. HET RASTER KOMT LATER. De collectiepagina wordt door de
      cedCommerce-filterapp opgebouwd NÁ dit script, en opnieuw getekend bij
      elke filterwijziging. Vandaar de MutationObserver plus twee herhaalde
      scans.

   2. GEEN IntersectionObserver. De browser berekent intersecties niet in een
      tabblad dat niet getekend wordt — dan vuurt de callback nooit en gebeurt
      er niets. Nu wordt alles gewoon verwerkt, in een wachtrij van vier.

   3. NIET getBoundingClientRect OP DE FOTO. Die geeft de ZICHTBARE maat, dus
      inclusief de transform die dit script er zelf net op heeft gezet. Daarom
      offsetWidth/offsetHeight: dat is de layoutmaat en die verandert niet
      mee. */

(function () {
  'use strict';

  var DOEL_B = 0.74;
  var DOEL_H = 0.64;
  var K_MIN = 0.70;
  var K_MAX = 1.60;
  var MEET_BREED = 96;
  var WIT = 246;
  var ALFA = 8;
  var TEGELIJK = 4;
  var SLEUTEL = 'ddz-fit-v2';

  var kast = {};
  try { kast = JSON.parse(localStorage.getItem(SLEUTEL) || '{}') || {}; } catch (e) { kast = {}; }
  var teBewaren = false;

  function bewaar() {
    if (!teBewaren) return;
    teBewaren = false;
    try {
      if (Object.keys(kast).length > 1500) kast = {};
      localStorage.setItem(SLEUTEL, JSON.stringify(kast));
    } catch (e) { /* vol of geblokkeerd: dan meten we volgende keer opnieuw */ }
  }

  function sleutelVan(src) {
    if (!src) return '';
    return src.split('?')[0].replace(/_(\d+)x(\.[a-z]+)$/i, '$2');
  }

  function meetUrl(src) {
    return src.split('?')[0] + '?width=' + MEET_BREED;
  }

  /* Geeft [x0, y0, breedte, hoogte, ondoorzichtig] terug, of null.
     ondoorzichtig = 1 als de RAND van de foto nergens doorzichtig is; dan is
     het geen vrijstaand product en hoort de tegel wit te zijn. */
  function meet(afb) {
    var W = afb.naturalWidth, H = afb.naturalHeight;
    if (!W || !H) return null;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.drawImage(afb, 0, 0);
    var d;
    try { d = x.getImageData(0, 0, W, H).data; } catch (e) { return null; }

    var x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (var yy = 0; yy < H; yy++) {
      for (var xx = 0; xx < W; xx++) {
        var o = (yy * W + xx) * 4;
        if (d[o + 3] < ALFA) continue;
        if (d[o] >= WIT && d[o + 1] >= WIT && d[o + 2] >= WIT) continue;
        if (xx < x0) x0 = xx;
        if (xx > x1) x1 = xx;
        if (yy < y0) y0 = yy;
        if (yy > y1) y1 = yy;
      }
    }
    if (x1 < 0) return null;

    /* rand aftasten: 40 punten langs de vier zijden. Is er nergens een
       doorzichtige pixel, dan is de foto niet uitgeknipt. */
    var doorzichtigGezien = 0;
    for (var i = 0; i < 40; i++) {
      var t = Math.floor(i * (W - 1) / 39);
      var b = Math.floor(i * (H - 1) / 39);
      var punten = [
        (0 * W + t) * 4,
        ((H - 1) * W + t) * 4,
        (b * W + 0) * 4,
        (b * W + (W - 1)) * 4
      ];
      for (var p = 0; p < 4; p++) {
        if (d[punten[p] + 3] < ALFA) { doorzichtigGezien++; }
      }
    }
    var ondoorzichtig = doorzichtigGezien === 0 ? 1 : 0;

    var bw = (x1 - x0 + 1) / W, bh = (y1 - y0 + 1) / H;
    if (bw * bh > 0.985 || bw * bh < 0.02) return null;
    return [+(x0 / W).toFixed(4), +(y0 / H).toFixed(4), +bw.toFixed(4), +bh.toFixed(4), ondoorzichtig];
  }

  function tegelVan(el) {
    var n = el.parentNode;
    while (n && n.nodeType === 1) {
      if (n.className && String(n.className).indexOf('ddz-tegel') >= 0) return n;
      n = n.parentNode;
    }
    return null;
  }

  function klaarMelden(afb) {
    if (afb.className.indexOf('ddz-fit-klaar') >= 0) return;
    setTimeout(function () { afb.className += ' ddz-fit-klaar'; }, 80);
  }

  /* zet de tegel op wit als de foto geen doorzichtige rand heeft */
  function tegelKleur(afb, ondoorzichtig) {
    var tegel = tegelVan(afb);
    if (!tegel) return;
    var heeft = String(tegel.className).indexOf('ddz-tegel--wit') >= 0;
    if (ondoorzichtig && !heeft) {
      tegel.className += ' ddz-tegel--wit';
    } else if (!ondoorzichtig && heeft) {
      tegel.className = String(tegel.className).replace(/\s*ddz-tegel--wit/g, '');
    }
  }

  function pas(afb, f, s) {
    if (!f || !afb.naturalWidth) return;
    tegelKleur(afb, f[4]);
    if (afb.getAttribute('data-ddz-gezet') === s) return;
    var tegel = tegelVan(afb);
    if (!tegel) return;

    /* LAYOUTmaten, niet de zichtbare maat — zie valkuil 3 bovenaan. */
    var tw = tegel.offsetWidth, th = tegel.offsetHeight;
    var vw = afb.offsetWidth, vh = afb.offsetHeight;
    if (!tw || !th || !vw || !vh) return;

    var cs = getComputedStyle(afb);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var cw = vw - pl - pr, ch = vh - pt - pb;
    if (cw <= 0 || ch <= 0) return;

    var ir = afb.naturalWidth / afb.naturalHeight;
    var rw, rh;
    if (cw / ch > ir) { rh = ch; rw = ch * ir; } else { rw = cw; rh = cw / ir; }

    var bw = f[2] * rw, bh = f[3] * rh;
    if (bw <= 0 || bh <= 0) return;

    var k = Math.min((tw * DOEL_B) / bw, (th * DOEL_H) / bh);
    if (k < K_MIN) k = K_MIN;
    if (k > K_MAX) k = K_MAX;

    var ox = (pl + cw / 2) - vw / 2 + ((f[0] + f[2] / 2) - 0.5) * rw;
    var oy = (pt + ch / 2) - vh / 2 + ((f[1] + f[3] / 2) - 0.5) * rh;

    afb.style.setProperty('--ddz-fit',
      'translate(' + (-ox * k).toFixed(2) + 'px,' + (-oy * k).toFixed(2) + 'px) scale(' + k.toFixed(4) + ')');
    afb.setAttribute('data-ddz-gezet', s);
    klaarMelden(afb);
  }

  function pasOveral(s, f) {
    var alle = document.getElementsByClassName('ddz-card-img');
    for (var i = 0; i < alle.length; i++) {
      if (sleutelVan(alle[i].currentSrc || alle[i].src) === s) pas(alle[i], f, s);
    }
  }

  var rij = [], bezig = 0, gestart = {};

  function volgende() {
    while (bezig < TEGELIJK && rij.length) {
      (function (taak) {
        bezig++;
        var proef = new Image();
        proef.crossOrigin = 'anonymous';
        proef.onload = function () {
          var f = meet(proef);
          kast[taak.s] = f || 0;
          teBewaren = true;
          if (f) pasOveral(taak.s, f);
          bezig--;
          bewaar();
          volgende();
        };
        proef.onerror = function () { bezig--; volgende(); };
        proef.src = meetUrl(taak.src);
      })(rij.shift());
    }
  }

  function behandel(afb) {
    if (!afb) return;
    var src = afb.currentSrc || afb.src;
    if (!src || src.indexOf('data:') === 0) return;
    var s = sleutelVan(src);
    if (!s) return;
    if (kast[s] === 0) { klaarMelden(afb); return; }
    if (kast[s]) { pas(afb, kast[s], s); return; }
    if (gestart[s]) return;
    gestart[s] = 1;
    rij.push({ s: s, src: src });
    volgende();
  }

  function scan() {
    var fs = document.getElementsByClassName('ddz-card-img');
    for (var i = 0; i < fs.length; i++) {
      var afb = fs[i];
      if (!tegelVan(afb)) continue;
      if (afb.complete && afb.naturalWidth > 2) behandel(afb);
      else if (!afb.getAttribute('data-ddz-wacht')) {
        afb.setAttribute('data-ddz-wacht', '1');
        afb.addEventListener('load', function () { behandel(this); });
      }
    }
  }

  function start() {
    scan();

    if ('MutationObserver' in window) {
      var wacht;
      var mo = new MutationObserver(function () {
        clearTimeout(wacht);
        wacht = setTimeout(scan, 80);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
    setTimeout(scan, 900);
    setTimeout(scan, 2600);

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var fs = document.getElementsByClassName('ddz-card-img');
        for (var i = 0; i < fs.length; i++) {
          var s = sleutelVan(fs[i].currentSrc || fs[i].src);
          if (kast[s]) { fs[i].removeAttribute('data-ddz-gezet'); pas(fs[i], kast[s], s); }
        }
      }, 180);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
